import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import '../CSS/Organizationform.css';
import { ENDPOINTS } from '../Helper/endpoints';
// import { useNavigate } from 'react-router-dom';

const Organizationform = ({ setIsLoggedIn, setCurrentPage }) => {
  const [organizationCode, setOrganizationCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!organizationCode || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'Input Error',
        text: 'Please fill in both fields.',
        customClass: {
          popup: 'small-swal-popup',
        },
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    setLoading(true);

    const url = ENDPOINTS.ORGANIZATION_LOGIN;

    axios
      .post(url, { organizations_code: organizationCode, pancard_no: password })
      .then((response) => {
        console.log('Response from API:', response.data);

        if (response.data.status) {
          console.log('Data to be stored in cookies:', response.data);
          Cookies.set('userSession', JSON.stringify(response.data), { expires: 7 });

          Swal.fire({
            icon: 'success',
            title: 'Login Successful',
            // text: response.data.msg,
            customClass: {
              popup: 'small-swal-popup',
            },
            showConfirmButton: false,
            timer: 1500,
          });

          setIsLoggedIn(true);
          setCurrentPage('UserList');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: response.data.message || 'Invalid credentials.',
            customClass: {
              popup: 'small-swal-popup',
            },
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch((error) => {
        console.error('Error from API:', error.response?.data || error.message);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || `An error occurred: ${error.message}`,
          customClass: {
            popup: 'small-swal-popup',
          },
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="organization-login">
      <i className="bi bi-arrow-left-circle-fill back-icon"
       onClick={() => setCurrentPage('Home')}></i>

      <h2>Organization Login</h2>
      <form onSubmit={handleSubmit}>
      <div className="form-group">
  <input
    type="text"
    className="form-control form-control-lg"
    id="organizationCode"
    value={organizationCode}
    placeholder="Enter Organization Code"
    onChange={(e) => setOrganizationCode(e.target.value)}
    required
    autoComplete="off"
  />
</div>

<div className="form-group">
  <input
    type="password"
    id="password"
    className="form-control form-control-lg"
    value={password}
    placeholder="Enter Password"
    onChange={(e) => setPassword(e.target.value)}
    required
    autoComplete="new-password"
  />
</div>


        <button type="submit" className="btn-organization" disabled={loading}>
          {loading ? 'Login' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Organizationform;
